import ViewPagerPhoto from './ViewPagerPhoto';

export default ViewPagerPhoto;
